export default __webpack_public_path__ + "static/media/viewdoc.651a4885.svg";